export default __webpack_public_path__ + "static/media/card-bg-1.23a33b1b.svg";